import { useMemo } from 'react';

// components
import Image from 'next/image';
import { Button } from '@/components/ui/button';
import Link from 'next/link';
import { Icon } from '@/components/ui/icon';
import VisibleLoading from '@/components/utilities/VisibleLoading';

// utilities
import { getImagePath } from '@/utils/images';

const FullImageCtaBlock = ({ image, claim, buttons, note }) => {
  return (
    <div className="relative mt-32 max-h-500 w-full">
      {image && (
        <Image
          src={getImagePath(image)}
          alt={image.alternativeText || 'Leadhub'}
          className="-z-10 object-cover"
          fill={true}
          priority={false}
        />
      )}

      <div
        className="relative flex w-full flex-col"
        style={{
          background: `
            linear-gradient(90deg, rgba(0, 0, 0, 0.00) 56.37%, rgba(0, 0, 0, 0.40) 100%),
            url(/noise.svg) 0% 0% / 250px 250px repeat
          `
        }}
      >
        <div className="absolute top-0 left-0 z-1 h-full w-full bg-[linear-gradient(0deg,rgba(0,0,0,0.00)_60%,var(--color-grey-950)_100%)]" />

        <div className="relative z-2 mx-auto flex h-screen min-h-128 w-[90vw] grow flex-col justify-center text-white xl:w-(--container-width)">
          <VisibleLoading delay={75}>
            {({ ref, className }) => (
              <h3 ref={ref} className={`max-w-[603px] text-center font-light xl:text-left ${className || ''}`.trim()}>
                {claim}
              </h3>
            )}
          </VisibleLoading>

          {(buttons || []).length > 0 && (
            <div className="mt-6 mb-6 flex flex-wrap gap-3">
              {buttons.map((button, index) => (
                <VisibleLoading key={button.id} delay={(index + 1) * 200}>
                  {({ ref, className }) => (
                    <Button
                      ref={ref}
                      key={button.id}
                      variant={button.variant}
                      size={button.size}
                      asChild={true}
                      className={`basis-full xl:basis-auto ${className || ''}`.trim()}
                    >
                      <Link href={button.url || ''}>
                        <Icon type={button.icon} /> {button.label}
                      </Link>
                    </Button>
                  )}
                </VisibleLoading>
              ))}
            </div>
          )}

          <VisibleLoading delay={150}>
            {({ ref, className }) => (
              <p
                ref={ref}
                className={`txt-md text-white-50 max-w-[485px] text-center font-medium xl:text-left ${className || ''}`.trim()}
              >
                {note}
              </p>
            )}
          </VisibleLoading>
        </div>
      </div>
    </div>
  );
};
export default FullImageCtaBlock;
